import React, { useEffect, useState, useRef } from 'react';
import {Products, Banner, Cart, Checkout } from './components';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import { commerce } from './lib/commerce';
import Sidebar from '../src/components/Sidebar/Sidebar';
import Navbar from '../src/components/Navbar/Navbar';
import About from '../src/components/About/About';
import Metode from '../src/components/Metode/Metode';
import Footer from '../src/components/Footer/Footer';

export const App = () => {
    const [products, setProducts] = useState([])
    const [cart, setCart] = useState({})
    const [order, setOrder] = useState({})
    const [errorMessage, setErrorMessage] = useState('');
    const [ isOpen, setIsOpen ] = useState(false);
    const refProduct = useRef(null);
    const refHome = useRef(null);
    const refFooter = useRef(null);
    const refAbout = useRef(null);
    const refMetod = useRef(null);

    const fetchProducts = async () => {
        const { data } = await commerce.products.list();
        setProducts(data)
    }

    const fetchCart = async () => {
        setCart(await commerce.cart.retrieve())
    }

    const handleAddToCart = async (productId, quantity) => {
        const { cart } = await commerce.cart.add(productId, quantity)
        setCart(cart)
        // if (cart.total_items === 10 ){
        //     alert("batasan order hanya 10")
        // }
    }

    console.log(handleAddToCart)

    const handleUpdateCartQty = async (productId, quantity) => {
        const { cart } = await commerce.cart.update(productId, { quantity });
        setCart(cart)
    }

    const handleRemoveFromCart = async (productId) => {
        const { cart } = await commerce.cart.remove(productId)
        setCart(cart)
    }

    const handleEmptyCart = async () => {
        const { cart } = await commerce.cart.empty()
        setCart(cart)
    }

    const refreshCart = async () => {
        const newCart = await commerce.cart.refresh();
        setCart(newCart)
    }

    const handleCaptureCheckout = async (checkoutTokenId, newOrder) => {
        try {
          const incomingOrder = await commerce.checkout.capture(checkoutTokenId, newOrder);
          setOrder(incomingOrder);
          refreshCart();
        } catch (error) {
          setErrorMessage(error.data.error.message);
        }
      };

    //componentDidMount Equivalent
    useEffect(() => {
        fetchProducts()
        fetchCart()
    }, [])
    
    const toggle = () => {
        setIsOpen(!isOpen);
    };

    return (
        <Router>
            <div>
                <Switch>
                    <Route exact path="/">
                        <Sidebar isOpen={ isOpen } toggle={ toggle } totalItems={cart.total_items} refAbout={refAbout} refFooter={refFooter} refMetod={refMetod} refHome={refHome}/>
                        <Navbar toggle={ toggle } totalItems={cart.total_items} refAbout={refAbout} refFooter={refFooter} refMetod={refMetod} refHome={refHome}/>
                        <Banner refProduct={refProduct} refHome={refHome}/>
                        <Products refProduct={refProduct} products={products} onAddToCart={handleAddToCart} totalItems={cart.total_items}/>
                        <About refAbout={refAbout}/>
                        <Metode refMetod={refMetod}/>    
                        <Footer refFooter={refFooter}/>
                    </Route>

                    <Route exact path="/cart">
                        <Cart cart={cart}
                            handleUpdateCartQty={handleUpdateCartQty}
                            handleRemoveFromCart={handleRemoveFromCart} 
                            handleEmptyCart={handleEmptyCart}
                        />
                    </Route>

                    <Route exact path="/checkout">
                        <Checkout 
                            cart={cart} 
                            order={order} 
                            onCaptureCheckout={handleCaptureCheckout} 
                            error={errorMessage}
                            refreshCart={refreshCart} />
                    </Route>

                </Switch>
            </div>
        </Router>
    )
}

export default App

